import React, { LegacyRef, RefObject, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tab } from 'semantic-ui-react';

import { InsightsState } from 'app-redux/InsightsState';
import * as dto from 'client/dto';

import { DiseaseAttributes } from 'components/DiseaseAttributes';

import diseaseActivityListSelectors from 'diseaseActivitiesInCountryLocations/diseaseActivityList.selectors';

import DiseaseActivityEventListPanel from './DiseaseActivityEventListPanel';

type DiseaseActivityListTabsProps = {
  diseaseActivityListTabsRef?: RefObject<HTMLElement>;
  refScrollToTabs?: React.MutableRefObject<HTMLDivElement>;
};

const DiseaseActivityListTabs: React.FC<DiseaseActivityListTabsProps> = ({
  diseaseActivityListTabsRef,
  refScrollToTabs,
}) => {
  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const handleOnTabChange = (e, { activeIndex }) => setActiveTabIndex(activeIndex);
  const diseaseActivityList = useSelector(diseaseActivityListSelectors.diseaseActivityList);
  const diseaseActivityEventList = useSelector<InsightsState, dto.GetEventModel[]>(
    diseaseActivityListSelectors.getFilteredEventList
  );

  const panes = [
    {
      menuItem: 'Disease Details',
      render: () => (
        <Tab.Pane>
          <DiseaseAttributes {...diseaseActivityList?.diseaseInformation} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Activity by Country',
      render: () => (
        <div
          ref={
            diseaseActivityListTabsRef
              ? (diseaseActivityListTabsRef as LegacyRef<HTMLDivElement>)
              : null
          }
        >
          <Tab.Pane>
            <DiseaseActivityEventListPanel isStandAlone={false} events={diseaseActivityEventList} />
          </Tab.Pane>
        </div>
      ),
    },
  ];

  return (
    <div ref={refScrollToTabs ? (refScrollToTabs as LegacyRef<HTMLDivElement>) : null}>
      <Tab
        menu={{ tabular: true }}
        panes={panes}
        activeIndex={activeTabIndex}
        onTabChange={handleOnTabChange}
      />
    </div>
  );
};

export default DiseaseActivityListTabs;
